export const publicRoutes = [
  '/login',
  '/signup',
  '/sent-email',
  '/activate',
  '/resetpassword',
  '/success',
  '/activate-failed',
  '/forgot-password',
  '/login/callback',
  '/verify-key',
  '/signup-email-sent',
  '/redirect',
  '/promotion',
  '/integrations/oauth-complete',
  '/composio/oauth/callback',
];
